import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import React, { ReactNode } from 'react';

import { CommonDialog } from '@/components/ui/deleteDialog/CommonDialog.comp.tsx';
import { themeColors } from '@/config/theme/themeColors.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

interface Props {
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  content?: string;
  name: ReactNode;
  onCancel: () => void;
  onConfirm: () => Promise<void> | void;
  title?: string;
}

export const DeleteDialog: React.FC<Props> = props => {
  const { cancelButtonLabel, confirmButtonLabel, content, name, onCancel, onConfirm, title } =
    props;
  const { t } = useTranslationWithPrefix('components.deleteDialog');

  return (
    <CommonDialog
      cancelButtonLabel={cancelButtonLabel ?? t('cancelButtonLabel')}
      confirmButtonLabel={confirmButtonLabel ?? t('confirmButtonLabel')}
      content={content ?? t('content')}
      icon={<WarningAmberIcon htmlColor={themeColors.red} sx={{ fontSize: 64 }} />}
      name={name}
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={title ?? t('title')}
    />
  );
};
